import { render, staticRenderFns } from "./TemplateRules.vue?vue&type=template&id=1271d9a5&scoped=true&"
import script from "./TemplateRules.vue?vue&type=script&lang=ts&"
export * from "./TemplateRules.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateRules.vue?vue&type=style&index=0&id=1271d9a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1271d9a5",
  null
  
)

export default component.exports